import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import './lib/amplify-config'  // configure Amplify before anything else
import { Hub } from 'aws-amplify/utils'
import { App } from './App'
import { useAuthStore } from './stores/authStore'

// Listen for Cognito auth events — primarily handles the async OAuth code
// exchange that occurs when Cognito redirects back to /auth/callback.
Hub.listen('auth', ({ payload }) => {
  const store = useAuthStore.getState()
  switch (payload.event) {
    case 'signedIn':
      // Tokens are now available — refresh auth state in the store.
      store.initAuth()
      break
    case 'signedOut':
      // Clear local auth state. Don't call store.signOut() here — that would
      // call Amplify's signOut() again and cause a redirect/promise loop.
      store.clearAuth()
      break
    case 'signInWithRedirect_failure':
      store.setError('Sign in failed. Please try again.')
      break
  }
})

// Try to restore an existing session before the first render.
// This prevents a flash of the loading spinner for already-authenticated users.
useAuthStore.getState().initAuth().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
})
